import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";

import { cn } from "@/lib/cn";
import { formatChange, formatPct, trendClass, trendOf } from "@/lib/format";

/** A coloured change with its sign: "+2.88%" in up-green, "−0.34%" in down-red. */
export function Change({
  value,
  kind = "pct",
  decimals = 2,
  arrow = false,
  className,
}: {
  value: number | null | undefined;
  kind?: "pct" | "abs";
  decimals?: number;
  arrow?: boolean;
  className?: string;
}) {
  const t = trendOf(value);
  const Icon = t === "up" ? ArrowUpRight : t === "down" ? ArrowDownRight : Minus;
  return (
    <span className={cn("num inline-flex items-center gap-0.5", trendClass(value), className)}>
      {arrow ? <Icon className="size-3.5" aria-hidden /> : null}
      {kind === "pct" ? formatPct(value, decimals) : formatChange(value, decimals)}
    </span>
  );
}

/** Background pill version, for heatmap-like lists. */
export function ChangePill({ value, decimals = 2 }: { value: number | null | undefined; decimals?: number }) {
  const t = trendOf(value);
  return (
    <span
      className={cn(
        "num inline-flex min-w-16 justify-end rounded-md px-1.5 py-0.5 text-xs font-semibold",
        t === "up" ? "bg-up-soft text-up" : t === "down" ? "bg-down-soft text-down" : "bg-surface-2 text-muted",
      )}
    >
      {formatPct(value, decimals)}
    </span>
  );
}
